<template>
  <RouterLink
    :to="{ name: ROUTE_NAME.SUBSCRIPTION }"
    :class="isMobile ? 'flex items-center gap-3 py-2 px-2 rounded-ds-md hover:bg-white/10' : undefined"
    @click="emit('click:item')"
  >
    <span
      class="flex items-center justify-center size-8.5 rounded-ds-sm shrink-0"
      :class="isMobile ? 'bg-white/10 text-primary-foreground' : 'bg-accent text-brand'"
    >
      <GemIcon
        class="size-4"
        aria-hidden="true"
      />
    </span>
    <span
      class="flex-1 flex flex-col leading-tight"
      :class="isMobile ? 'min-w-0' : undefined"
    >
      <span
        class="font-bold"
        :class="isMobile ? 'text-[15px] text-primary-foreground' : 'text-sm text-foreground'"
      >{{ currentPlanName }} plan</span>
      <span
        class="text-xs font-medium"
        :class="isMobile ? 'text-primary-foreground/70' : 'text-muted-foreground'"
      >Go to subscription</span>
    </span>
    <ChevronRightIcon
      class="size-4 shrink-0"
      :class="isMobile ? 'text-primary-foreground/60' : 'text-muted-foreground'"
      aria-hidden="true"
    />
  </RouterLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { RouterLink } from 'vue-router'

import { ROUTE_NAME } from '@/const'

import { useUserSubscriptionsStore } from '@/store/user/subscriptions'

import { GemIcon, ChevronRightIcon } from '@lucide/vue'

defineProps<{
  isMobile?: boolean
}>()

const emit = defineEmits<{
  (e: 'click:item'): void
}>()

const userSubscriptionsStore = useUserSubscriptionsStore()

const currentPlanName = computed(() => {
  const plan = userSubscriptionsStore.getCurrentPlan?.name
  if (!plan) return undefined
  return plan.charAt(0).toUpperCase() + plan.slice(1)
})
</script>
